import { Controller } from "@hotwired/stimulus"

const YOUTUBE_ID_REGEX = /(youtu(?:\.be|be\.com)\/(?:.*v(?:\/|=)|(?:.*\/)?)([\w'-]+))/i

export default class extends Controller {
  static get targets() {
    return ["body"]
  }

  static get values() {
    return { videoId: String }
  }

  connect() {
    this.render()
  }

  onUrlInput(event) {
    const match = YOUTUBE_ID_REGEX.exec(event.target.value)
    this.updateVideo(match ? match[2] : "")
  }

  removeVideo() {
    this.updateVideo("")
  }

  updateVideo(videoId) {
    // Only re-render (swapping the URL input for the embed, or vice versa)
    // when the mode actually changes - re-rendering on every keystroke would
    // destroy and recreate the input element the user is still typing into.
    const modeChanged = Boolean(this.videoIdValue) !== Boolean(videoId)
    this.videoIdValue = videoId
    if (modeChanged) this.render()
    this.dispatch("changed", {
      detail: { blockData: { video_source: "youtube", video_id: videoId } },
      prefix: "homer-block"
    })
  }

  render() {
    this.bodyTarget.innerHTML = this.videoIdValue ? this.embedHtml() : this.chooserHtml()
  }

  embedHtml() {
    const src = `https://www.youtube.com/embed/${this.videoIdValue}`
    return `
      <div class="video-block-editor__video-wrapper">
        <iframe src="${src}" frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="half-spacing-unit">
        <div class="btn btn-default" data-action="click->homer-video-block#removeVideo">Remove and choose another video.</div>
      </div>
    `
  }

  chooserHtml() {
    return `
      <div class="text-center">
        <h4 class="bold">Please copy and paste the URL of a YouTube video.</h4>
        <div class="text-center">
          <input type="text" class="video-block-editor__url-textbox form-control"
                 data-action="input->homer-video-block#onUrlInput">
        </div>
      </div>
    `
  }
}
